'use client'

import Button from "@/components/button/Button"
import Field from "@/components/form/Field"
import FormCell from "@/components/form/FieldCell"
import FormCells from "@/components/form/FieldCells"
import FieldLabel from "@/components/form/FieldLabel"
import Form from "@/components/form/Form"
import ApiUtils from "@/utils/ApiUtils"
import { DM_FIELDS } from "@dealermesh/react"
import { useState } from "react"

export default function EditProfileForm(props) {
  
  const [form,setForm] = useState({
    firstName: props.user.first_name || "",
    lastName: props.user.last_name || "",
    email: props.user.email || "",
    phone: props.user.phone || "",
  })
  const [errors,setErrors] = useState([])
  
  const onFieldChange = (name, value) => {
    let data = Object.assign({}, form)
    data[name] = value
    setForm(data)
  }
  
  const isValid = (check) => {
    let errorList = []
    if (!form.firstName) {
      errorList.push({ field: "firstName", message: "First name is required." })
    }
    if (!form.lastName) {
      errorList.push({ field: "lastName", message: "Last name is required." })
    }
    if (!form.email) {
      errorList.push({ field: "email", message: "Email is required." })
    }
    if (!check) {
      setErrors(errorList)
    }
    return errorList.length == 0
  }
  
  const onSubmit = (e) => {
    let payload = {
      first_name: form.firstName,
      last_name: form.lastName,
      email: form.email
    }
    ApiUtils.postRequest("/console/api/users/register", payload)
    .then(data => {
      if (props.onSubmit) props.onSubmit(data)
    })
  }
  
  return <Form id="lead_form" name="Lead Form" onSubmit={e => onSubmit(e)}>
    <section>
      <section>
        <FormCells>
          <FormCell size={props.size}>
            <FieldLabel for={DM_FIELDS.CONTACT_EMAIL}>Email</FieldLabel>
            <h3>{ form.email }</h3>
          </FormCell>
          <FormCell size={props.size}>
            <FieldLabel for={DM_FIELDS.CONTACT_FIRST_NAME}>First Name*</FieldLabel>
            <Field type="text" name={DM_FIELDS.CONTACT_FIRST_NAME} placeholder="First Name*" value={form.firstName} onChange={value => onFieldChange("firstName", value)}></Field>
          </FormCell>
          <FormCell size={props.size}>
            <FieldLabel for={DM_FIELDS.CONTACT_LAST_NAME}>Last Name*</FieldLabel>
            <Field type="text" name={DM_FIELDS.CONTACT_LAST_NAME} placeholder="Last Name*" value={form.lastName} onChange={value => onFieldChange("lastName", value)}></Field>
          </FormCell>
          {/* <FormCell size={props.size}>
            <FieldLabel for={DM_FIELDS.CONTACT_EMAIL}>Email*</FieldLabel>
            <Field type="text" name={DM_FIELDS.CONTACT_EMAIL} placeholder="Email*" value={form.email} onChange={value => onFieldChange("email", value)} readOnly={true}></Field>
          </FormCell> */}
          {/* <FormCell size={props.size}>
            <FieldLabel for={DM_FIELDS.CONTACT_MOBILE_PHONE}>Phone*</FieldLabel>
            <Field type="text" name={DM_FIELDS.CONTACT_MOBILE_PHONE} placeholder="Phone (optional)" value={form.phone} onChange={value => onFieldChange("phone", value)}></Field>
          </FormCell> */}
          <FormCell size={props.size}>
            <Button type="submit" theme={['secondary']} label="Save" disabled={!isValid(true)}></Button>
          </FormCell>
        </FormCells>
      </section>
    </section>
  </Form>
  
}